import { useState } from "react";
import { intl } from "LocaleWrapper";
import { Button, FormGroup } from "@cofano/cck";
import { CustomDialog } from "components/dialogs/Dialogs";
import ShipBayPlanTemplateSelect, { ShipBayPlanTemplateSelectOption } from "view/ships/components/selects/ShipBayPlanTemplateSelect";

type SelectTemplateDialogProps = {
	open: boolean;
	onClose: () => void;
	onChange: (template: ShipBayPlanTemplateSelectOption) => void;
	bayPlan: {
		rows: number;
		bays: number;
		tiers: number;
	};
};

const SelectBayPlanTemplateDialog = ({ open, onClose, onChange, bayPlan }: SelectTemplateDialogProps) => {

	const [ template, selectTemplate ] = useState<ShipBayPlanTemplateSelectOption | null>(null);

	const handleOnClose = () => {
		onClose();
		selectTemplate(null);
	};

	return (
		<CustomDialog
			open={open}
			onClose={handleOnClose}
			title={intl.formatMessage({ id: "USE_TEMPLATE" })}
			actions={(
				<Button
					size="small"
					disabled={!template}
					onClick={() => {
						if (template) {
							onChange(template);
						}

						handleOnClose();
					}}>
					{intl.formatMessage({ id: "CONFIRM" })}
				</Button>
			)}>
			<FormGroup label={intl.formatMessage({ id: "TEMPLATE" })} overflow="hidden">
				<ShipBayPlanTemplateSelect
					value={template}
					onChange={option => selectTemplate(option)}
					rows={bayPlan.rows}
					bays={bayPlan.bays}
					tiers={bayPlan.tiers} />
			</FormGroup>
		</CustomDialog>
	);
};

export default SelectBayPlanTemplateDialog;
